<template>
    <div id="charLib">
        <div class="group-panel">
            <div class="group-panel__header">
                <div>
                    <el-button type="primary" size="medium" @click="addEditGroup(null)">增加分组</el-button>
                </div>
            </div>
            <div class="group-container" :style="{height: `${windowHeight - 190}px`}">
                <div class="group-item--title">全部分组</div>
                <div @click="groupClickHandler(groupItem)"
                     :class="['group-item', currentGroup && currentGroup.id == groupItem.id ? 'group-item--active' : '']"
                     v-for="groupItem in groupList">
                    {{groupItem.title}}
                    <i class="fa fa-trash" @click.stop="deleteGroup(groupItem)"></i>
                    <i class="fa fa-edit" @click.stop="addEditGroup(groupItem)"></i>
                </div>
            </div>

        </div>
        <div class="main-panel" :style="{width: `${windowWidth - 580}px`}">
            <div>
                <div class="main-panel__header">

                    <el-button type="primary" size="medium" @click="isShowBatchAddChar = true">批量增加</el-button>
                    <el-button type="primary" size="medium" @click="batchMoveChar()">移动到组</el-button>
                    <el-button type="danger" size="medium" @click="batchDeleteChar()">批量删除</el-button>
                    <el-input style="width: 240px" class="search-input search-input--right"
                              size="medium"
                              placeholder="" icon="el-icon-search" @keyup.enter.native="handleInputChange"
                              v-model.trim="wordName">
                        <el-button slot="append" size="medium" icon="el-icon-search"
                                   @click="handleInputChange"></el-button>
                    </el-input>
                </div>
                <div class="char-list">
                    <div @click="charClickHandler(charItem)" :class="['char-item', selectedCharIdList.includes(charItem.id) ? 'char-item--active' : '']" v-for="charItem in charList">
                        <i class="fa fa-edit" @click.stop="editChar(charItem)"></i>
                        {{charItem.name}}
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="新增" :visible.sync="isShowAddEditGroupDialog" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form ref="addEditGroupForm" :model="addEditGroupForm" :rules="addEditGroupFormRules"
                         label-width="120px">
                    <el-form-item label="分组名称" prop="title">
                        <el-input :maxlength="20" v-model.trim="addEditGroupForm.title" placeholder="分组名称(1-20个符)" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="排序号" prop="orderNum">
                        <el-input v-model.trim="addEditGroupForm.orderNum" placeholder="只能输入大于或等于0的数字（由小到大排序）" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input :maxlength="100" v-model.trim="addEditGroupForm.remark" placeholder="备注(1-100个符)" style="width: 400px;"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowAddEditGroupDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="addEditGroupConfirm()">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="添加汉字" :visible.sync="isShowBatchAddChar" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form ref="batchAddCharForm" :model="batchAddCharForm" :rules="batchAddCharFormRules"
                         label-width="120px">
                    <el-form-item label="字库汉字" prop="stockStr">
                        <el-input type="textarea" :maxlength="1000" :rows="5" v-model.trim="batchAddCharForm.stockStr" style="width: 400px;"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowBatchAddChar = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="batchAddChar()">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="移动到组" :visible.sync="isShowMoveChar" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form label-width="120px">
                    <el-form-item label="移动到分组">
                        <el-select v-model.trim="moveToGroupId" placeholder="请选择">
                            <el-option v-for="item in moveGroupList" :key="item.id" :label="item.title"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowMoveChar = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="batchMoveCharConfirm()">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="编辑汉字" :visible.sync="isShowEditChar" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <div class="char-container">{{charDetail.name}}</div>
                <div class="form-item-container">
                    <span class="dialog-label">微视频：</span><span class="dialog-value ">
                        <span class="uploader-container">
                            <uploader style="width: 150px" pathPrefix="playWord" :multiple="false" :extList="['mp4','flv']"  v-model="videoJson" ></uploader>
                        </span>
                    </span>
                </div>
                <div class="form-item-container form-item-container--line">
                    <span class="dialog-label">笔画：</span><span class="dialog-value">
                    <uploader pathPrefix="playWord" v-model="picJson" :extList="['gif']" showMode="image" showResult="image" :lineList="false"></uploader>
                    </span>
                </div>
                <div class="form-item-container form-item-container--voice">
                    <span class="dialog-label">读音：</span><span class="dialog-value ">
                        <div class="add-line" @click="addVoice()">
                                <i class="fa fa-plus"></i>&nbsp;&nbsp;新增选项
                            </div>
                            <div style="margin-bottom: 10px;" v-for="(voiceItem, index) in voiceList">
                                <el-input style="width: 200px;" size="small" v-model="voiceItem.voice"></el-input>
                                <i class="fa fa-close" @click="removeVoice(index)"></i>
                            </div>
                    </span>
                </div>
                <div class="form-item-container form-item-container--voice">
                    <span class="dialog-label">词组：</span><span class="dialog-value ">
                        <div class="add-line" @click="addPhrase()">
                                <i class="fa fa-plus"></i>&nbsp;&nbsp;新增选项
                            </div>
                            <div style="margin-bottom: 10px;" v-for="(phraseItem, index) in phraseList">
                                <el-input style="width: 200px;" size="small" v-model="phraseItem.phrase"></el-input>
                                <i class="fa fa-close" @click="removePhrase(index)"></i>
                            </div>
                    </span>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowEditChar = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="editCharConfirm()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize.js';
    import baseMixin from '@/mixins/baseMixin.js';

    import {
        getPlayWordGroupList,
        getPlayWordGroupStockList,
        addPlayWordGroup,
        updatePlayWordGroup,
        delPlayWordGroup,
        getPlayWordGroupById,
        addPlayWordGroupStockList,
        delPlayWordGroupStockByIds,
        movePlayWordGroupStockList,
        getPlayWordGroupStockByName,
        getPlayWordGroupStockInfo,
        addAndUpdatePlayWordGroupStockInfo
    } from '@/api/chineseChar';
    import Uploader from '@/components/Uploader/WebUploader';

    export default {
        name: "charLib",
        mixins: [windowResize, baseMixin],
        components: {Uploader},
        data() {
            const validateOrderNum = (rule, value, callback) => {
                value = `${value}`.trim();
                if (value === '') {
                    callback(new Error('排序号不能为空'));
                } else if(!/^\d+$/.test(value)) {
                    callback(new Error('请输入数字'));
                } else {
                    callback();
                }
            };
            const validateStockStr = (rule, value, callback) => {
                value = `${value}`.trim();
                if (value === '') {
                    callback(new Error('字库汉字不能为空'));
                } else if(/[^\u4E00-\u9FA5]/.test(value)) {
                    callback(new Error('请输入汉字'));
                } else {
                    callback();
                }
            };
            return {
                groupList: [],
                currentGroup: null,
                addEditGroupForm: {
                    orderNum: 0,
                    remark: '',
                    title: ''
                },
                addEditGroupFormRules: {
                    title: [
                        { required: true, message: '请输入分组名称', trigger: 'blur' },
                    ],
                    orderNum: [
                        { required: true, validator: validateOrderNum },
                    ],
                },
                charList: [],
                selectedCharList: [],
                selectedCharIdList: [],
                isShowAddEditGroupDialog: false,
                editGroup: null,

                isShowBatchAddChar: false,
                batchAddCharFormRules: {
                    stockStr: [
                        { required: true, validator: validateStockStr },
                    ]
                },
                batchAddCharForm: {
                    stockStr: ''
                },

                isShowMoveChar: false,
                moveToGroupId: '',
                moveGroupList: [],

                wordName: '',

                isShowEditChar: false,
                charDetail: {
                    name: ''
                },
                videoJson:[],
                picJson: [],
                voiceList: [],
                phraseList: []

            }
        },
        created() {
            this.getPlayWordGroupListFunc();
        },
        methods: {
            addVoice() {
                this.voiceList.push({
                    voice: ''
                })
            },
            addPhrase() {
                this.phraseList.push({
                    phrase: ''
                })
            },
            removePhrase(index) {
                this.phraseList.splice(1, index);
            },
            removeVoice(index) {
                this.voiceList.splice(1, index);
            },
            editChar(charItem) {
                console.log(charItem);
                getPlayWordGroupStockInfo({
                    wordName: charItem.name
                })
                    .then(data => {
                        data.name = data.name || charItem.name;
                        this.charDetail = data;
                        if(data.photoJson) {
                            this.picJson = [{
                                fileUrl: data.photoJson
                            }];
                        } else {
                            this.picJson = [];
                        }
                        if(data.videoJsonObj && data.videoJsonObj.accessUrl) {
                            this.videoJson = [{
                                fileUrl: data.videoJsonObj.accessUrl,
                                fileName: data.videoJsonObj.accessUrl
                            }];
                        } else {
                            this.videoJson = [];
                        }
                        this.voiceList = data.soundList.map(voice => ({
                            voice
                        }));
                        this.phraseList = data.phraseList.map(phrase => ({
                            phrase
                        }));
                        this.isShowEditChar = true;
                    })
            },
            editCharConfirm() {
                addAndUpdatePlayWordGroupStockInfo({
                    name: this.charDetail.name,
                    photoJson: this.picJson.length !== 0 ? this.picJson[0].fileUrl : '',
                    soundJson: this.voiceList.filter(item => item.voice.trim() !== '').map(item => item.voice),
                    phraseJson: this.phraseList.filter(item => item.phrase.trim() !== '').map(item => item.phrase),
                    videoJson: this.videoJson.length !== 0 ? {
                        fileName: this.videoJson[0].fileName,
                        accessUrl: this.videoJson[0].fileUrl
                    } : {
                        fileName: '',
                        accessUrl: ''
                    },
                    voiceJson: {fileName:"",accessUrl:""}
                })
                    .then(() => {
                        this.$message.success('编辑成功');
                        this.wordName = '';
                        this.selectedCharList = [];
                        this.selectedCharIdList = [];
                        this.getPlayWordGroupListFunc();
                        this.isShowEditChar = false;
                    })
            },
            handleInputChange() {
                this.selectedCharList = [];
                this.selectedCharIdList = [];
                this.wordName = this.wordName.trim();
                if(this.wordName !== '') {
                    getPlayWordGroupStockByName({
                        wordName: this.wordName
                    })
                        .then(data => {
                            this.currentGroup = this.groupList.find(item => item.id == data.groupId);
                            this.getPlayWordGroupStockListFunc();
                        });
                } else {
                    this.getPlayWordGroupStockListFunc();
                }

            },
            batchMoveCharConfirm() {
                this.$confirm("确认要移动这些汉字吗？", "移动", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    movePlayWordGroupStockList({
                        groupId: this.moveToGroupId,
                        stockIds: this.selectedCharIdList.join(',')
                    })
                        .then(() => {
                            this.wordName = '';
                            this.isShowMoveChar = false;
                            this.$message.success('移动成功');
                            this.selectedCharList = [];
                            this.selectedCharIdList = [];
                            this.getPlayWordGroupListFunc();
                        })
                });
            },
            batchMoveChar() {
                if(this.selectedCharIdList.length === 0) {
                    this.$message.error('请选择汉字');
                } else {
                    this.isShowMoveChar = true;
                    this.moveGroupList = this.groupList.filter(item => this.currentGroup.id != item.id);
                    if(this.moveGroupList.length !== 0) {
                        this.moveToGroupId = this.moveGroupList[0].id;
                    }
                }

            },
            batchDeleteChar() {
                if(this.selectedCharIdList.length === 0) {
                    this.$message.error('请选择汉字');
                } else {
                    this.$confirm("确认要删除吗？", "删除", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                        lockScroll: false
                    }).then(() => {
                        delPlayWordGroupStockByIds({
                            stockIds: this.selectedCharIdList.join(',')
                        })
                            .then(() => {
                                this.wordName = '';
                                this.$message.success('删除成功');
                                this.selectedCharList = [];
                                this.selectedCharIdList = [];
                                this.getPlayWordGroupListFunc();
                            })
                    });
                }
            },
            batchAddChar() {
                this.batchAddCharForm.stockStr = this.batchAddCharForm.stockStr.trim();
                this.$refs.batchAddCharForm.validate(isValid => {
                    if(isValid) {
                        addPlayWordGroupStockList({
                            id: this.currentGroup.id,
                            stockStr: this.batchAddCharForm.stockStr
                        })
                            .then(() => {
                                this.wordName = '';
                                this.$message.success(`添加成功`);
                                this.isShowBatchAddChar = false;
                                this.batchAddCharForm.stockStr = '';
                                this.getPlayWordGroupListFunc();
                            })
                    }
                })
            },
            deleteGroup(groupItem) {
                this.$confirm("确认要删除吗？", "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    delPlayWordGroup({
                        groupId: groupItem.id
                    })
                        .then(() => {
                            this.wordName = '';
                            this.$message.success('删除成功');
                            this.selectedCharList = [];
                            this.selectedCharIdList = [];
                            this.getPlayWordGroupListFunc();
                        })
                });
            },
            addEditGroup(editGroup) {
                this.editGroup = editGroup;
                if(editGroup) {
                    getPlayWordGroupById({
                        groupId: editGroup.id
                    })
                        .then(data => {
                            this.addEditGroupForm = data;
                        })
                } else {
                    this.addEditGroupForm = {
                        orderNum: 0,
                        remark: '',
                        title: ''
                    }
                }
                this.isShowAddEditGroupDialog = true;
            },
            addEditGroupConfirm() {
                this.$refs.addEditGroupForm.validate(isValid => {
                    if(isValid) {
                        const args = JSON.parse(JSON.stringify(this.addEditGroupForm));
                        if(this.editGroup) {
                            args.id = this.editGroup.id;
                        }
                        new Promise(resolve => {
                            if(this.editGroup) {
                                updatePlayWordGroup(args).then(resolve);
                            } else {
                                addPlayWordGroup(args).then(resolve);
                            }
                        })
                            .then(() => {
                                this.$message.success(`${this.editGroup ? '编辑' : '新增'}成功`);
                                this.isShowAddEditGroupDialog = false;
                                this.getPlayWordGroupListFunc();
                            })
                    }
                })
            },
            charClickHandler(charItem) {
                const index = this.selectedCharList.findIndex(item => item.id == charItem.id);
                if(index !== -1) {
                    this.selectedCharList.splice(index, 1);
                    this.selectedCharIdList.splice(index, 1);
                } else {
                    this.selectedCharList.push(charItem);
                    this.selectedCharIdList.push(charItem.id);
                }
            },
            groupClickHandler(groupItem) {
                if(groupItem.id != this.currentGroup.id) {
                    this.wordName = '';
                    this.currentGroup = groupItem;
                    this.getPlayWordGroupStockListFunc();
                    this.selectedCharIdList = [];
                    this.selectedCharList = [];
                }
            },
            getPlayWordGroupListFunc() {

                getPlayWordGroupList()
                    .then(data => {
                        this.groupList = data;
                        if (data.length !== 0) {
                            if(this.currentGroup === null) {
                                this.currentGroup = data[0];
                            }
                            this.getPlayWordGroupStockListFunc();
                        }
                    })
            },
            getPlayWordGroupStockListFunc() {

                getPlayWordGroupStockList({
                    groupId: this.currentGroup.id
                })
                    .then(data => {
                        if(this.wordName) {
                            data = data.filter(item => this.wordName.includes(item.name));
                        }
                        this.charList = data;
                    });
            }

        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    #charLib {
        height: 100%;
    }

    .group-container {
        height: 300px;
        overflow-y: auto;
        @include scrollBar;
        width: 260px;

    }
    .group-panel__header {
        padding: 12px;
        top: 0;
    }
    .group-panel {
        position: relative;
        float: left;
        width: 260px;
        border-right: 1px solid #f1f1f1;
    }

    .main-panel {
        float: left;
        padding: 12px;
    }

    .title {
        margin: 10px 0;
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;
    }

    .group-item--title {
        width: 100px;
        height: 26px;
        margin-left: 20px;
        margin-top: 10px;
        display: block;
        color: #7B7B7B;
    }

    .group-item {
        height: 30px;
        text-align: left;
        line-height: 30px;
        display: block;
        padding: 0 30px;
        cursor: pointer;
        border-radius: 2px;
        position: relative;

        .fa {
            float: right;
            margin: 7px 0 0 10px;
            display: none;
        }
        &:hover {
            background-color: #ECECEC;
            .fa {
                display: block;
            }
        }
        &.group-item--active {
            background-color: #409EFF;
            color: #fff;
            .fa-edit {
                color: #fff;
            }
        }
        .fa-trash {
            color: #f08080;
        }
        .fa-edit {
            color: #409EFF;
        }
    }
    .char-list {
        padding-top: 12px;
    }
    .char-item {
        float: left;
        box-sizing: border-box;
        width: 80px;
        height: 80px;
        border: 2px solid #ddd;
        margin: 0 10px 10px 0;
        text-align: center;
        padding: 14px;
        font-size: 36px;
        cursor: pointer;
        position: relative;
        .fa-edit {
            position: absolute;
            font-size: 16px;
            right: 5px;
            top: 5px;
            color: #409EFF;
            display: none;
        }
        &:hover {
            .fa-edit {
                display: block;
            }
        }
        &.char-item--active {
            border: 2px solid #409EFF;
        }
    }
    .main-panel__header {
        padding-bottom: 10px;
        border-bottom: 1px solid #e4e7ed;
    }
    .char-container {
        width: 70px;
        height: 70px;
        font-size: 52px;
        margin: 0 auto;
        text-align: center;
        line-height: 80px;
        margin-bottom: 5px;
    }
    .form-item-container {
        width: 500px;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 10px;
    }
    .dialog-value {
        display: inline-block;
        vertical-align: middle;
        width: 280px;
        text-align: left;
    }
    .uploader-container {
        width: 140px;
    }
    .dialog-label {
        display: inline-block;
        vertical-align: middle;
        width: 200px;
        text-align: right;
        margin-right: 10px;
    }
    .add-line {
        color: #409EFF;
        cursor: pointer;
    }
    .form-item-container--voice {
        & > * {
            vertical-align: top;
        }
        .fa-close {
            color: #f08080;
            margin-left: 10px;
        }
    }
</style>
<style lang="scss">
    .dialog-form .is-current.is-focusable > .el-tree-node__content {
        background-color: #20a0ff !important;
        color: #fff !important;
    }
    #charLib .form-item-container--line {
        .upload-file-item {
            width: 80px;
            height: 80px;
        }
        .upload-file-item img {
            margin: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/study/charLib/charLib.vue